<web-banners-header [banners]="bannersCarruselHome"></web-banners-header>

<!-- Proyecto ESPERANTO-COSITALNETWORK -->
<section class="project-esperanto general-structure-full-width">
  <div class="general-structure">
    <h3>{{'home.projectEsperantoTitle'|translate}}</h3>
    <p class="text-content" [innerHTML]="'home.projectEsperantoText'|translate"></p>
  </div>
</section>

<!-- Accesos directos -->
<section class="direct-access">
  <a routerLink="/fondos-comunitarios/informacion" class="link" data-target="fondos-comunitarios">
    <mat-icon svgIcon="ico-fondos-comunitarios"></mat-icon>
    <span>{{'home.directAccess.t01'|translate}}</span>
  </a>
  <a routerLink="/portales/14/portal-de-secretaria" class="link" data-target="portales">
    <mat-icon svgIcon="ico-portal-secretaria"></mat-icon>
    <span>{{'home.directAccess.t02'|translate}}</span>
  </a>
  <!-- <a href="https://biblioteca.nubedelectura.com/cloudLibrary/ebook/list" target="_blank" class="link"
    data-target="biblioteca">
    <mat-icon svgIcon="ico-biblioteca"></mat-icon>
    <span>{{'home.directAccess.t03'|translate}}</span>
  </a> -->
  <a href="#" (click)="handleToBanner('https://biblioteca.nubedelectura.com/cloudLibrary/ebook/list', $event)" class="link" data-target="biblioteca">
    <mat-icon svgIcon="ico-biblioteca"></mat-icon>
    <span>{{'home.directAccess.t03' | translate}}</span>
  </a>
  <a routerLink="/cursos/1/online" class="link" data-target="cursos">
    <mat-icon svgIcon="ico-cursos"></mat-icon>
    <span>{{'home.directAccess.t04'|translate}}</span>
  </a>
  <a routerLink="/cursos/2/jornadas" class="link" data-target="jornadas">
    <mat-icon svgIcon="ico-jornadas"></mat-icon>
    <span>{{'home.directAccess.t05'|translate}}</span>
  </a>
  <a routerLink="/documentacion-jornadas" class="link" data-target="documentacion">
    <mat-icon svgIcon="ico-documentacion"></mat-icon>
    <span>{{'home.directAccess.t06'|translate}}</span>
  </a>
</section>

<!-- Ultimas noticias (novedades) -->
<section class="latest-news">
  <header class="header">
    <mat-icon svgIcon="ico-logo"></mat-icon>
    <h3>{{'home.lastNews'|translate}}</h3>
    <button mat-flat-button color="accent" class="see-more-btn" (click)="more(CONTENTS_NEWS)"
      [title]="'home.all'|translate">
      <div class="button-inner">
        <mat-icon svgIcon="see-more"></mat-icon>
        <span>{{'general.readMore' | translate}}</span>
      </div>
    </button>
  </header>
  <web-home-grid-content [content$]="gridContent$"></web-home-grid-content>
</section>

<div class="group">

  <!-- Observatorios y Portales -->
  <section class="observatories-and-portals">
    <header class="header" data-type="observatories">
      <mat-icon svgIcon="ico-observatories"></mat-icon>
      <h3>{{'home.observatories'|translate}}</h3>
      <button mat-flat-button color="accent" class="see-more-btn" (click)="more(CONTENTS_OBSERVATORIES_PORTALS)"
        [title]="'home.all'|translate">
        <div class="button-inner">
          <mat-icon svgIcon="see-more"></mat-icon>
          <span>{{'general.readMore' | translate}}</span>
        </div>
      </button>
    </header>
    <web-home-grid-content [content$]="contentsObservatoriesPortals$" classList="observatories"></web-home-grid-content>
  </section>

  <aside class="aside">
    <!-- Calendario -->
    <web-calendar [events$]="events$" [loadingEvents$]="loadingEvents$"
      (dateSelected)="dateSelected($event)"></web-calendar>

    <!-- Banners -->
    @if (!isMobile) {
    <section class="banners">
      <web-banners-sidenav [banners]="bannersSidenav"></web-banners-sidenav>
    </section>
    }

    <!-- Redes sociales -->
    <div class="social">
      <h3>¡Síguenos en nuestas redes!</h3>
      <p class="text-content">No te pierdas ninguna novedad y mantente al día con nuestras últimas noticias, eventos y
        contenido exclusivo. ¡Únete a nuestra comunidad!</p>
      <div class="social-links">
        <a href="https://twitter.com/Cositalnetwork" title="X" target="_blank">
          <span class="icon-x"></span>
        </a>
        <a href="https://www.facebook.com/pages/Cositalnetwork/371811616242353?ref=stream" title="facebook"
          target="_blank">
          <span class="icon-facebook"></span>
        </a>
        <a href="https://t.me/joinchat/AAAAAFZDu7pxB2Zxtq3B9w" title="telegram" target="_blank">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M15 10l-4 4l6 6l4 -16l-18 7l4 2l2 6l3 -4" />
          </svg>
        </a>
      </div>
    </div>
  </aside>

</div>

<!-- Más artículos -->
<section class="more-articles" [style.display]="(listContent$|async)?.length===0 ? 'none' : 'block'">
  <header class="header" data-type="more-articles">
    <mat-icon svgIcon="see-more"></mat-icon>
    <h3>{{'home.moreArticles'|translate}}</h3>
  </header>
  <web-home-list-content [content$]="listContent$"></web-home-list-content>
</section>

<!-- Consultas -->
<section class="queries">
  <header class="header" data-type="queries">
    <mat-icon svgIcon="ico-queries"></mat-icon>
    <h3>{{'home.queries'|translate}}</h3>
  </header>
  <main class="queries-types">
    <section>
      <header class="queries-types-header">
        <h4>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M8 16v-4a4 4 0 0 1 8 0v4" />
            <path d="M3 12h1m8 -9v1m8 8h1m-15.4 -6.4l.7 .7m12.1 -.7l-.7 .7" />
            <path d="M6 16m0 1a1 1 0 0 1 1 -1h10a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1z" />
          </svg>
          <span>{{'home.featuredQueries'|translate}}</span>
        </h4>
        <button mat-flat-button color="accent" class="see-more-btn" (click)="more(CONTACTS_FEATURED)"
          [title]="'home.all'|translate">
          <div class="button-inner">
            <mat-icon svgIcon="see-more"></mat-icon>
            <span>{{'general.readMore' | translate}}</span>
          </div>
        </button>
      </header>
      @for (query of queries.slice(0, 5); track query.contactID) {
      <article class="query" [routerLink]="query.url">
        <label class="open" *ngIf="query.open">Abierta</label>
        <p class="category">{{query.contactType}}</p>
        <h4 class="title">{{query.subject}}</h4>
        <div class="text-content num-lines-4" [innerHTML]="query.text|safeHtml"></div>
      </article>
      }
    </section>
    <section>
      <header class="queries-types-header">
        <h4>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"
            stroke-linecap="round" stroke-linejoin="round">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path
              d="M17.8 19.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z" />
            <path
              d="M6.2 19.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z" />
            <path
              d="M12 9.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z" />
          </svg>
          <span>{{'home.ratingQueries'|translate}}</span>
        </h4>
        <button mat-flat-button color="accent" class="see-more-btn" (click)="more(CONTACTS_BEST_RATINGS)"
          [title]="'home.all'|translate">
          <div class="button-inner">
            <mat-icon svgIcon="see-more"></mat-icon>
            <span>{{'general.readMore' | translate}}</span>
          </div>
        </button>
      </header>
      @for (query of queriesBestRatings.slice(0, 5); track query.contactID) {
      <article class="query" [routerLink]="query.url">
        <label class="open" *ngIf="query.open">Abierta</label>
        <p class="category">{{query.contactType}}</p>
        <h4 class="title">{{query.subject}}</h4>
        <div class="text-content num-lines-4" [innerHTML]="query.text|safeHtml"></div>
      </article>
      }
    </section>
  </main>
</section>

<!-- Banners -->
@if (isMobile) {
<section class="banners banners-mobile">
  <web-banners-sidenav [banners]="bannersSidenav"></web-banners-sidenav>
</section>
}
